import React from "react";

import GetSvgIcon from "../../SvgIcons/SvgIcon";

//CSS
import "./IconButton.css";

export default function IconButton({
  onClick,
  icon,
  btnStyle,
  disabled,
  size = ["2rem", "2rem"],
}) {
  const IconComponent = GetSvgIcon(icon);

  const STYLES = [
    "btn-primary",
    "btn-negative",
    "btn-positive",
    "btn-disabled",
  ];
  const checkButtonStyle = disabled
    ? STYLES[3]
    : STYLES.includes(btnStyle)
    ? btnStyle
    : STYLES[0];

  return (
    <div
      className={"icon-animate-parent icon-btn " + checkButtonStyle}
      onClick={onClick}
      style={{ width: size[0], height: size[1] }}
    >
      <IconComponent />
    </div>
  );
}
